'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInitialMessageText = undefined;

var _reselect = require('reselect');

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

var _getWelcomeMessage = require('./getWelcomeMessage');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getInitialMessageText = exports.getInitialMessageText = (0, _reselect.createSelector)(_getWelcomeMessage.getWelcomeMessage, (0, _get2.default)('initialMessage'));


//////////////////
// WEBPACK FOOTER
// ./js/selectors/widgetDataSelectors/getInitialMessageText.js
// module id = 282
// module chunks = 2 3